import { logger } from 'src/logger/KatalLoggerClient';
import { ExceptionDetail, toExceptionDetail } from 'src/models/ExceptionDetail';
import {
  CreateOrUpdateQueuesFormData,
  CreateOrUpdateQueuesRequest
} from 'src/models/ServiceRequests/CaseAuthorityServiceRequests';
import { CreateOrUpdateQueuesResponse } from 'src/models/ServiceResponses/CaseAuthorityServiceResponses';
import { CaseAuthorityService } from 'src/service/CaseAuthorityService';
import AsyncRequestHandler from 'src/utils/HttpUtils/HttpHandler';

const buildEditQueuesRequest = (
  domainId: string,
  updatedBy: string,
  queueDetails: CreateOrUpdateQueuesFormData
): CreateOrUpdateQueuesRequest => {
  return {
    domainId: domainId,
    queueId: queueDetails.queueId,
    name: queueDetails.name,
    additionalAttributes: queueDetails.additionalAttributes
      ? queueDetails.additionalAttributes
      : JSON.stringify({}),
    description: queueDetails.description,
    lastUpdatedBy: updatedBy,
    userOperation: queueDetails.userOperation
  };
};

const buildCreateOrEditQueuesResponse = (
  response
): CreateOrUpdateQueuesResponse => {
  return {
    ...response
  } as CreateOrUpdateQueuesResponse;
};

const buildCreateOrUpdateQueuesException = (error): ExceptionDetail => {
  return toExceptionDetail(error);
};

const buildCreateQueueRequest = (
  domainId: string,
  createdBy: string,
  queueDetails: CreateOrUpdateQueuesFormData
): CreateOrUpdateQueuesRequest => {
  return {
    domainId: domainId,
    queueId: queueDetails.queueId,
    name: queueDetails.name,
    additionalAttributes: queueDetails.additionalAttributes
      ? queueDetails.additionalAttributes
      : JSON.stringify({}),
    description: queueDetails.description,
    createdBy: createdBy,
    lastUpdatedBy: createdBy,
    userOperation: queueDetails.userOperation
  };
};

const createQueue = async (
  domainId: string,
  createdBy: string,
  queueDetails: CreateOrUpdateQueuesFormData
) => {
  try {
    const createQueueRequest = buildCreateQueueRequest(
      domainId,
      createdBy,
      queueDetails
    );
    const response = await AsyncRequestHandler(
      CaseAuthorityService.createOrUpdateQueue(createQueueRequest)
    );
    return buildCreateOrEditQueuesResponse(response);
  } catch (error) {
    void logger.error('Create Queue call failed', error.message).then();
    throw buildCreateOrUpdateQueuesException(error);
  }
};

const editQueue = async (
  domainId: string,
  updatedBy: string,
  queueDetails: CreateOrUpdateQueuesFormData
) => {
  try {
    const editQueueRequest = buildEditQueuesRequest(
      domainId,
      updatedBy,
      queueDetails
    );
    const response = await AsyncRequestHandler(
      CaseAuthorityService.createOrUpdateQueue(editQueueRequest)
    );
    return buildCreateOrEditQueuesResponse(response);
  } catch (error) {
    void logger.error('Edit Queue call failed', error.message).then();
    throw buildCreateOrUpdateQueuesException(error);
  }
};

const CreateOrUpdateQueuesBuilder = {
  createQueue,
  editQueue
};

export default CreateOrUpdateQueuesBuilder;
